export default __webpack_public_path__ + "61bb6e6d8cab7270a54b192b042e2b3e.woff2";